import { RegistrationForm } from "components/Auth/Register/Register";
import { StagingLoginForm } from "components/Auth/StagingLogin/StagingLogin";
import StagingAuthContext from "context/StagingAuthContext";
import { useContext } from "react";
import AuthScreenContainer from "./AuthScreenContainer";

export const RegisterContainer = () => {
  const { isLoggedIn: stagingAuth } = useContext(StagingAuthContext);
  if (process.env.REACT_APP_STAGING_PROTECTION === "true" && !stagingAuth) {
    return (
      <AuthScreenContainer heading="QuiX - Master Password">
        <StagingLoginForm />
      </AuthScreenContainer>
    );
  }

  return <RegistrationForm />;
};
